const axios = require('axios');

(() => {
  const init = () => {
    if (location.pathname !== process.env.JS_BASE_URL + 'customer/mypage') {
      return
    }
    showCompleteModal();
  }

  const showCompleteModal = () => {
    const token = $('meta[name="csrf-token"]').attr('content');
    axios({
      url: process.env.JS_BASE_URL + 'customer/mypage/change_coupon_modal',
      method: 'POST',
      data: $('form').serialize(),
      withCredentials: true,
      headers: { 'X-CSRF-Token': token }
    })
    .then(response => {
      if (response.data.show_modal === true) {
        $('#mypage-stamp-modal').click();
      }
    })
    .catch(error => {
      console.log(error);
      return error;
    })
  }
  $(init);
})();


